<script>
import {maxValue, required} from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

/* COMPOSANTS */
import AkButtonAction from '@components/v2/general/AkButtonAction.vue';
import AkInputMoney from '@components/v2/input/AkInputMoney.vue';
import GaView from '@components/v2/layout/GaView';

/* MIXINS */
import randomRef from '@mixins/randomRef';
import utilsMixin from '@mixins/utilsMixin';
import messageMixin from '@mixins/messageMixin';
import loaderMixin from '@mixins/loaderMixin';

/* SERVICES */
import settingService from '@services/settingService';

export default {
  components: {
    AkInputMoney,
    AkButtonAction,
    GaView,
  },
  mixins: [randomRef, utilsMixin, messageMixin, loaderMixin],
  setup() {
    return {v$: useVuelidate()};
  },
  validations() {
    return {
      revenueObjective: {required, maxValue: maxValue(100000000)},
    };
  },
  head() {
    return {
      title: 'Statistiques',
    };
  },
  data() {
    return {
      setting: {
        name: 'REVENUE_OBJECTIVE',
        type: 'DOUBLE',
        val: null,
      },
      revenueObjective: null,
    };
  },
  mounted() {
    this.showLoader();
    settingService
      .setting('REVENUE_OBJECTIVE')
      .then((data) => {
        this.revenueObjective = data.val;
        this.setting = data;
        this.setting.type = 'DOUBLE';
      })
      .finally(() => {
        this.hideLoader();
      });
  },
  methods: {
    setObjective() {
      this.v$.$touch();
      if (this.v$.$error) {
        return;
      }
      this.setting.val = this.revenueObjective;
      settingService.update(this.setting).then(() => {
        this.success('Votre objectif annuel a été modifié avec succès');
      });
    },
  },
};
</script>

<template>
  <GaView :ref="ref" :title="$t('Statistiques')">
    <template #action>
      <div class="flex justify-end">
        <AkButtonAction little label="Modifier" @click="setObjective()" />
      </div>
    </template>

    <template #content>
      <AkInputMoney
        v-model="revenueObjective"
        label="Objectifs de volumes d’affaires annuel"
        information="Objectifs de volumes d’affaires annuel"
        :validator="v$.revenueObjective" />
    </template>

    <template #extra> </template>
  </GaView>
</template>
